<template>
  <!-- banner -->
  <section v-if="bannerTopo != ''" class="hero-wrap hero-wrap-2"
    :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
    <div class="overlay"></div>
    <div class="container">
      <div class="row no-gutters slider-text align-items-end">
        <div class="col-md-9 pb-5">
          <h1 class="mb-0 bread">{{ bannerTopo[0].itiNome }}</h1>
        </div>
      </div>
    </div>
  </section>
  <!-- END banner -->

  <!-- blog -->
  <section v-if="listaBlog.length > 0" class="ftco-section ftco-no-pb">
    <div class="container">

      <div class="row d-flex">
  <div v-for="noticia in listaBlog" :key="noticia.itiId" class="col-md-4">
    <div class="blog-entry">
      <router-link
        :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
        class="block-20 img-wrapper"
      >
        <img
          :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem"
          class="img-fluid" style="border: 1px solid #cccccc;border-radius: 5px;"
        />
      </router-link>
      <div class="text d-block text-center">
        <h3 class="heading">
          <router-link
            :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
          >
            {{ noticia.itiNome }}
          </router-link>
        </h3>
      </div>
    </div>
  </div>
</div>

      <!--<div class="row mt-5" style="margin-bottom: 100px;">
        <div class="col">
          <div class="block-27">
            <ul>
              <li><a href="#">&lt;</a></li>
              <li class="active"><span>1</span></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li><a href="#">4</a></li>
              <li><a href="#">5</a></li>
              <li><a href="#">&gt;</a></li>
            </ul>
          </div>
        </div>
      </div>-->
    </div>

  </section>
</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';


export default {
  name: 'BlogView',
  components: {

  },

  data: () => ({
    bannerTopo: [],
    listaBlog: [],
    seoHome: [],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(titulo, texto, palavrasChave) {
      useHead({
        title: titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Performance Elevadores" },
          { name: "keywords", content: palavrasChave }, 
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    textoLimpoSemHtml(value) {
      return value.replace(/<[^>]*>/g, ''); 
     },
  },

  created() {
    axios.get('/Process/InsInstitucional/institucional/55/seoblog/0/x')
      .then(response => {
        this.seoHome = response.data;
        let seoHome0 = this.seoHome[0];
        seoHome0.itiResumo1 = this.textoLimpoSemHtml(seoHome0.itiResumo1);
        seoHome0.itiResumo2 = this.textoLimpoSemHtml(seoHome0.itiResumo2);

        this.carregaMetas(seoHome0.itiNome, seoHome0.itiResumo1, seoHome0.itiResumo2);
        //console.log('topo seo')
        //console.log(this.seoHome)
      })
      .catch(error => {
        console.error(error);
      });

    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/47/blogtopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    //aqui busca notícias
    axios.get('/Process/InsInstitucional/institucional/48/listablog/0/x')
      .then(response => {
        this.listaBlog = response.data;
        //console.log('noticias')
        //console.log(this.listaBlog)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped>

.img-wrapper {
  display: block;
  width: 100%;
  height: 250px; /* Ajuste conforme desejado */
  overflow: hidden;
}

.img-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Mantém a proporção cortando o excesso */
  object-position: center; /* Centraliza a imagem */
}

</style>